import { render, staticRenderFns } from "./DocumentUpload.vue?vue&type=template&id=2ab9e8be&scoped=true"
import script from "./DocumentUpload.vue?vue&type=script&lang=js"
export * from "./DocumentUpload.vue?vue&type=script&lang=js"
import style0 from "./DocumentUpload.vue?vue&type=style&index=0&id=2ab9e8be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab9e8be",
  null
  
)

export default component.exports